import { useAuthContext } from '../../contexts/AuthProvider';
import useConfigActions from '../../hooks/APIHooks/appointments/useConfigActions';
import AcademiaNotFound from '../CommonComps/AcademiaNotFound';
import NoTableDataFound from '../CommonComps/NoTableDataFound';
import SectionHeader from '../CommonComps/Titles/SectionHeader';
import ProfileConfigRow from './ProfileConfigRow';

const ProfileConfigInfo = () => {
  // integration of context hooks here
  const { currentUserType, currentUser } = useAuthContext();

  // integration of custom API hooks here
  const { getServiceConfigsByIdHandler } = useConfigActions(
    '',
    currentUserType === 'user' ? currentUser?.id : undefined
  );

  console.log('SERVICE CONFIGS: ', getServiceConfigsByIdHandler.data?.data);

  // rendering profile config info component here
  return (
    <>
      {getServiceConfigsByIdHandler.isSuccess ? (
        <div className='p-5 rounded-xl shadow-academia-sm'>
          <SectionHeader headerText='Configurations' />

          {getServiceConfigsByIdHandler.data.data.length ? (
            <div className='overflow-auto'>
              <div className='w-fit md:w-full grid grid-cols-profile-config-table text-center text-base-dark-green font-medium border-b-2 border-dashed border-base-dark-green pb-1'>
                <p>Service Name</p>
                <p>Working Hours</p>
                <p>Slot Duration</p>
                <p>Buffer Time</p>
                <p>Reschedule Limit</p>
                <p>Working Days</p>
              </div>

              <div>
                {getServiceConfigsByIdHandler.data.data.map((config) => (
                  <ProfileConfigRow key={config.id} config={config} />
                ))}
              </div>
            </div>
          ) : (
            <NoTableDataFound message='No Configurations Found!!' />
          )}
        </div>
      ) : (
        <AcademiaNotFound message='Failed to load Configurations data!!' />
      )}
    </>
  );
};

export default ProfileConfigInfo;
